import {useState} from "react";

// Scss
import '../assets/css/partnerPortal/welcome.scss';
import ButtonArrow from "./ButtonArrow";


function ItemRow(props) {

  const [title] = useState(props.title);
  const [buttonName] = useState(props.buttonName);
  const [link] = useState(props.link);

  return (
    <>
      
    <div className="infoItemRow">
        <div className="quoteSignatureGeneral fontWeight600">{title}</div>
            
    </div>
    <ButtonArrow buttonName={buttonName} link={link} />
    <div className="blackLine"></div>
            
    </>
  );


}

export default ItemRow;

